import constants from "../../../constants";
import { useParams } from "react-router-dom";
import { getDataFromStorage } from "../../../util";
import TestSvgIcon from "../../../Svg/TestSvgIcon";
import React, { useContext, useEffect, useState } from "react";
import Overlay from "../../CommonComponents/Overlay";
import ReportHooks from "../../../Hooks/ReportHooks";
import AlertContext from "../../../context/AlertContext";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import { UserReportContext } from "../../../context/UserReportContext";
import useCommonFunctionHooks from "../../../Hooks/useCommonFunctionHooks";
import UserTestResultReportTableHooks from "../../../Hooks/UserReport/UserTestResultReportTable/UserTestResultReportTableHooks";
import Loading from "../../Notification-Loading/Loading/Loading";

export default function UserTestResultReportTable({learnerId}) {
  const Alert = useContext(AlertContext);
  const UserReportCxt = useContext(UserReportContext);
  const isLearner =  getDataFromStorage("role") === constants.Roles.learner;
  const axios = useAxiosPrivate();
  const { handleOpenTestOrAssignment } = ReportHooks();
  const useCommonFunctionHks = useCommonFunctionHooks();
  const UserTestResultReportTableHks = UserTestResultReportTableHooks();

  const { id } = useParams();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    axios
      .get(
        `node/learner/${
          (Alert.isAdmin && !Alert.isFromProfile.current) ||
          (getDataFromStorage("role") === "hr" && !Alert.isFromProfile.current)
            ? learnerId
            : Alert.isFromProfile.current ||
              getDataFromStorage("role") === "customer"
            ? Alert.selectedBid.lid
            : getDataFromStorage("learnerid")
        }/batch/${
          (Alert.isAdmin && !Alert.isFromProfile.current) ||
          (getDataFromStorage("role") === "hr" && !Alert.isFromProfile.current)
            ? id
            : Alert.isFromProfile.current ||
              getDataFromStorage("role") === "customer"
            ? Alert.selectedBid.bid
            : localStorage.getItem("batchid")
        }/testpoints?istagged=false`,
        useCommonFunctionHks.getHeaderDetailsForAxios()
      )
      .then((res) => {
        if (res.data.resultCode === constants.RESULT_STATUS.TECHNICAL_ERROR) {
          Alert.setShowNotify({
            show: true,
            title: "Info",
            msg: res.data.msg,
          });
        } else {
          if (
            Object.keys(res.data).length === 0 ||
            res.data.resultCode === constants.RESULT_STATUS.NO_DATA
          ) {
            UserReportCxt.setUserTestResultTableData([]);
            Alert.setShowNotify({
              show: true,
              title: "Info",
              msg: "No data to display",
            });
          } else {
            res.data.data.data.sort(
              (item1, item2) => item1.orderno - item2.orderno
            );

            UserTestResultReportTableHks.generateDataForUserTestResultReportTable(
              res.data.data.data
            );
          }
        }
      })
      .catch((error) => {
        useCommonFunctionHks.getCatchBlockDetails(error);
      })
      .finally(() => setLoading(false));
  }, [
    localStorage.getItem("batchid"),
    learnerId,
  ]);

  // console.log("UserTestResultReportTable mounted", UserReportCxt.userTestResultTableData);

  const getTestReport = (data) => {
    console.log("data...................",data);
    
    const dueDate = data.assignedDate ? new Date(data.assignedDate) : null;
    const now = new Date();
    const batchType = parseInt(localStorage.getItem("batchType"));

    // console.log("duedate", dueDate);


    // If test not submitted
    if (data.score.split("/")[0] === "null" && isLearner) {
      if (dueDate && now < dueDate && batchType !== constants.BATCH_TYPE.SELF) {
        Alert.setShowNotify({
          show: true,
          title: "Info",
          msg: `You haven’t submitted the test yet! Please submit before the deadline.`,
        });
      } else if (dueDate && now > dueDate && batchType !== constants.BATCH_TYPE.SELF) {
        Alert.setShowNotify({
          show: true,
          title: "Info",
          msg: "The deadline for this test has expired. Please contact your trainer for assistance.",
        });
      } else {
        Alert.setShowNotify({
          show: true,
          title: "Info",
          msg: "There is no data to show for this test.",
        });
      }
      return;
    }

    
    // If proctored test (restricted)
    if (data?.viewTest !== constants.DISPLAY_TEST_RESULT.ALL && isLearner) {
      Alert.setShowNotify({
        show: true,
        title: "Restricted",
        msg: "This is a proctored test. Question view is unavailable.",
      });
      return;
    }

    if(!isLearner){

    }

    let json = {
      status: 2,
      mid: data.mId,
      tid: data.id,
      tname: data.name,
      modName: data.mName,
      topicid: data.topicid,
      libtype: data.libtype,
      lpcid: data.lpcid,
      topicname: data.topicname,
      testConfigId: data.tcId,
      from: Alert.isAdmin ? "user" : "learner",
      index: UserReportCxt.currentLearnerDetails.ind,
      lname: UserReportCxt.currentLearnerDetails.label,
      learnerid:
        (Alert.isAdmin && !Alert.isFromProfile.current) ||
        (getDataFromStorage("role") === "hr" && !Alert.isFromProfile.current)
          ? learnerId
          : Alert.isFromProfile.current ||
            getDataFromStorage("role") === "customer"
          ? Alert.selectedBid.lid
          : getDataFromStorage("learnerid"),
      proctored: 0,
      apiattributes: {
        testqnno: 1,
        lpid: data.lpId,
        questionid: data.qnid,
      },
      // filterattributes: {
      //   proctored: 0,
      // },
    };

    // Normal test view
    handleOpenTestOrAssignment(json, "testpoints");
  };

  

  return (
    <div
      className={
        !Alert.isAdmin && getDataFromStorage("role") !== "hr"
          ? "userTestResultReportTableMainContainer"
          : "userTestResultReportTableMainContainerForAdmin"
      }
    >
      {loading && <Loading overlay/>};
      {UserReportCxt.userTestResultTableData.length === 0 ? (
        <div className="userTestResultReportTableNoResponse">
          <h4>No data to show the test results</h4>
        </div>
      ) : (
        UserReportCxt.userTestResultTableData.map((lp, index) => (
        <div
          key={lp.lpId}
          className={
            !Alert.isAdmin && getDataFromStorage("role") !== "hr"
              ? "userTestResultReportTableContainer"
              : "userTestResultReportTableContainerForAdmin"
          }
        >
          <div className="userTestResultReportTableLearningPathName">
            {lp.lpName}
          </div>
          <div className="userTestResultReportTableTestMainHeader">
            <div className="userTestResultReportTableTestHeader">
              <div className="userTestResultReportTableTest">Test Name</div>
              <div className="userTestResultReportTableTotalPoints">
                Total Points
              </div>
              <div className="userTestResultReportTableMyScore">
                {Alert.isAdmin ? "Score" : "My Score"}
              </div>
            </div>
            <div className="userTestResultReportTablePointsScored">
              Points Scored
            </div>
          </div>
          {lp.modules.map((module, index) => (
            <div className="userTestResultReportTableTestBody">
              <div
                key={module.mId}
                className="userTestResultReportTableTestBodyModuleName"
              >
                {module.mName}
              </div>

              {module.test.map((test, index) => (
                <div
                  key={test.lpcid}
                  onClick={() => getTestReport(test)}
                  className="userTestResultReportTableTestBodyData"
                >
                  <div className="userTestResultReportTableTestBodyDataTestLabelDiv">
                    <div className="userTestResultReportTableTestBodyDataTestSvgIcon">
                      <TestSvgIcon
                        active={true}
                        disable={false}
                        libType={test.libtype}
                      />
                    </div>

                    <div className="userTestResultReportTableTestBodyDataTestName">
                      <Overlay
                        key={test.id}
                        title={test.name}
                        component={
                          <div className="userTestResultReportTableTestBodyDataTestNameLabel">
                            {test.name}
                          </div>
                        }
                      />
                      <div className="userTestResultReportTableTestBodyDataTestAssignedDate">
                        {test.assignedDate}
                      </div>
                    </div>
                    <div className="userTestResultReportTableTestBodyDataTestWeightage">
                      {test.weightage}
                    </div>
                    {/* <div className="userTestResultReportTableTestBodyDataTestMyScore">
                      {test.score.split("/")[0] === "null"
                        ? "-"
                        : test.score.split("/")[0]}
                      /{test.score.split("/")[1]}
                    </div> */}
                    <div className="userTestResultReportTableTestBodyDataTestMyScore">
                      {test.score.split("/")[0] == "null"
                        ? "-"
                        : Number.isInteger(parseFloat(test.score.split("/")[0]))
                        ? parseFloat(test.score.split("/")[0])
                        : parseFloat(test.score.split("/")[0]).toFixed(2)}
                      /{test.score.split("/")[1]=="null"?0:test.score.split("/")[1]}
                    </div>
                    <div className="userTestResultReportTableTestBodyDataTestPointsEarned">
                      {test.pointsEarned}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
          <div className="userTestResultReportTableTestBodyDataTotalTestPointsEarned">
            <div className="userTestResultReportTableTestBodyDataTotalTestPointsEarnedLabel">
              Total
            </div>
            <div className="userTestResultReportTableTestBodyDataTotalTestPointsEarnedValue">
              {UserTestResultReportTableHks.calculateTotalEarnedPointsPerLearningpath(lp)}
            </div>
          </div>
        </div>
       ))
      )}
    </div>
  );
}
